import React, { useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { MoreVertical, Check } from 'lucide-react';


function ValidateHeaderMenutItem({ sendHiddenHeaders, dataColumns, sendUpdatedDataColumns }) {

    const [updatedDataColumns, setUpdatedDataColumns] = useState(dataColumns);

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);

    };

    const toggleColumn = (index) => {
        const nextDataColumns = updatedDataColumns.map((column, columnIndex) => (
            columnIndex === index ? { ...column, state: column.state !== true } : column
        ));
        const nextHiddenHeaders = nextDataColumns
            .filter(column => column.state !== true)
            .map(column => column.name);

        setUpdatedDataColumns(nextDataColumns);
        sendUpdatedDataColumns(nextDataColumns);
        sendHiddenHeaders(nextHiddenHeaders);
    }


    return (
        <div>
            <button
                className="oct_dropdown-trigger-v2"
                aria-label="Choose table columns"
                onClick={(e) => { handleClick(e); }}>
                <MoreVertical className="oct_icon" />
            </button>
            <Menu
                className="oct_menu-v2 oct_column-menu-v2"
                id="header-dots-options"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                MenuListProps={{ onSubmit: handleClose }}
            >
                <div className="oct_column-menu-title-v2">Columns</div>
                {
                    updatedDataColumns.map(({ name, state }, index) => (
                        <MenuItem className="oct_menu-item-v2 oct_column-menu-item-v2" key={index} onClick={() => toggleColumn(index)}>
                            <span className="oct_column-menu-check-v2">
                                {state === true ? <Check className="oct_icon" /> : null}
                            </span>
                            <span>{name}</span>
                        </MenuItem>
                    ))
                }
            </Menu>
        </div>
    );
}

export default ValidateHeaderMenutItem;
